import React from "react";
import { Box, Grid2, Typography } from "@mui/material";

import HeaderComponent from "../../HeaderComponent/HeaderComponent";
import RecentItems from "../../RecentActivities/RecentActivitiesAndInsight";
import BarsDataset from "../../BinOverview.tsx/BinGraph";
import DLCPlot from "./DLCPlot";
import DLCGraph from "./DLCGraph";
import moment from "moment";
import { useTranslation } from "react-i18next";

const DLCDashboard: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ width: "100%", mt: 10.5 }}>
      <HeaderComponent />
      <Grid2 container spacing={2} style={{ height: "100vh" }}>
        <Grid2 size={{ xs: 9, sm: 9, md: 8.5, xl: 8.5, lg: 8.5 }}>
          <DLCGraph />
        </Grid2>
        <Grid2 size={{ xs: 3, sm: 3, md: 3.5, xl: 3.5, lg: 3.5 }}>
          <RecentItems />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 12, xl: 12, lg: 12 }}>
          <DLCPlot />
        </Grid2>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#000000",
              marginBottom: 1,
            }}
          >
            {t("global.copyRight")} © {moment().year()},{" "}
            {t("global.copyRightText")}
          </Typography>
        </Box>
      </Grid2>
    </Box>
  );
};

export default DLCDashboard;
